import React from "react";
import { Button, Input, InputCleaner } from "component-library";
import { SearchIcon } from "assets";
import "./ControllableSearch.scss";

export interface IControllableSearchProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: (search: string) => void;
  placeholder?: string;
  onClear?: () => void;
}

export const ControllableSearch: React.FC<
  React.PropsWithChildren<IControllableSearchProps>
> = (props) => {
  const handleCleanClick = (event: React.MouseEvent<Element, MouseEvent>) => {
    event.stopPropagation();
    props.onClear?.();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      props.onSearch(props.value);
    }
  };

  return (
    <div className="c-search">
      <Input
        type="text"
        placeholder={props.placeholder}
        onChange={props.onChange}
        onKeyDown={handleKeyDown}
        value={props.value}
        className="c-search__input"
      >
        <div className="c-search__children-wrapper">
          {props.value && <InputCleaner onClick={handleCleanClick} />}
        </div>
      </Input>
      <div className="c-search__button-wrapper">
        <Button
          onClick={() => props.onSearch(props.value)}
          type="primary"
          text=""
          svgIcon={<SearchIcon />}
          aria-label={props.placeholder}
        />
      </div>
    </div>
  );
};
